import { render, staticRenderFns } from "./comp_AppBar-MenuWithActivator.vue?vue&type=template&id=23791e06&scoped=true"
import script from "./comp_AppBar-MenuWithActivator.vue?vue&type=script&lang=js"
export * from "./comp_AppBar-MenuWithActivator.vue?vue&type=script&lang=js"
import style0 from "./comp_AppBar-MenuWithActivator.vue?vue&type=style&index=0&id=23791e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23791e06",
  null
  
)

export default component.exports